import { Component, OnInit } from '@angular/core';
import {IconBaseComponent} from '../base/icon-base.component';

@Component({
  selector: 'app-icon-danger',
  templateUrl: './icon-danger.component.html',
  styleUrls: ['./icon-danger.component.scss']
})
export class IconDangerComponent extends IconBaseComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
